import React, { useState } from "react";

import AreaChart, { IAreaChartProps } from "@Components/activity/AreaChart";
import { Radio, SwitchProps, Typography } from "antd";
import Toggle from "./Toggle";

export interface IRadioChartData {
    description?: string;
    options?: Record<string, unknown>;
    title?: string;
    toggleOptions?: SwitchProps;
}

interface IRadioChartOptions<ChartValueType> extends IAreaChartProps<ChartValueType> {
    chartType: "area";
    title: string;

    handleActivitySelect: (userId: string, activityInstanceId: string) => void;
}

interface IRadioChartProps<T> {
    options: IRadioChartOptions<T>;
    data: IRadioChartData[];
    showLabels?: boolean;
}

const CHART_TYPES = {
    area: AreaChart,
};

function RadioChart<ChartValueType>({ data: allData = [], options, showLabels }: IRadioChartProps<ChartValueType>) {
    const [index, setIndex] = useState(0);
    const data = allData.filter((d) => d);
    const datum = data[index];
    if (!datum) return null;
    const { chartType, ...otherOptions } = options;
    const { description, options: chartOptions = {}, title, toggleOptions } = datum;

    const ChartType = CHART_TYPES[options.chartType];

    const hasToggle = !!toggleOptions;

    return (
        <>
            {hasToggle ? <Toggle {...toggleOptions} position="position-top-right" /> : null}
            <Radio.Group value={index} className="newUI-raised" onChange={({ target }) => setIndex(+target.value)}>
                {data.map((d, buttonIndex) => (
                    <Radio.Button key={d.title} value={buttonIndex}>
                        {d.title}
                    </Radio.Button>
                ))}
            </Radio.Group>
            {title && showLabels ? (
                <Typography.Title level={3} style={{ width: "100%" }}>
                    {title}
                </Typography.Title>
            ) : null}

            {description ? <span style={{ margin: "20px 0px 30px 0px", display: "block" }}>{description}</span> : null}
            {ChartType ? <ChartType {...{ ...otherOptions, ...chartOptions }} /> : null}
        </>
    );
};

export default RadioChart;
